import { Box, Grid, Stack, Typography } from "@mui/material";

type CardSectionProps = {
    label: string;
    IconComponent: React.ElementType;
    children: React.ReactNode;
};

// A small tinted, labeled section wrapper for entity cards (ExpertCard, ReferenceCard, ...) -
// groups related IconTextRow fields under a visible heading instead of letting them float in
// one flat, undifferentiated block.
function CardSection({ label, IconComponent, children }: CardSectionProps) {
    return (
        <Box
            sx={{
                backgroundColor: 'action.hover',
                borderRadius: 1.5,
                padding: 1.5,
                marginTop: 1.5,
            }}
        >
            <Stack direction="row" alignItems="center" gap={0.75} sx={{ marginBottom: 1 }}>
                <IconComponent fontSize="small" color="primary" />
                <Typography variant="overline" color="primary" sx={{ fontWeight: 600, lineHeight: 1 }}>
                    {label}
                </Typography>
            </Stack>
            <Grid container justifyContent="space-evenly" rowSpacing={0.5}>
                {children}
            </Grid>
        </Box>
    );
}

export default CardSection;
